import { Component, Input, OnInit } from '@angular/core';
import { CarouselInterface } from '@app/core/interfaces';

@Component({
    selector: 'ins-news-item',
    templateUrl: 'news-item.component.html',
    styleUrls: ['news-item.component.scss'],
})
export class NewsItemComponent implements OnInit {
    @Input() data: CarouselInterface;
    public imageWebpData: string;

    public ngOnInit(): void {
        this.imageWebpData = this.data.images?.xs?.abs_url.replace('.png', '.webp');
    }
}
